import React, { useEffect, useState } from "react";

const LOGO_URL =
    "img/SAS_LOGO.png";

export default function Header() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
                scrolled
                    ? "bg-white/90 backdrop-blur-md border-b border-slate-200/70"
                    : "bg-white/60 backdrop-blur-sm"
            }`}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 h-24 sm:h-28 md:h-32 flex items-center justify-between gap-3">
                <a
                    href="#top"
                    data-testid="header-logo-link"
                    className="flex items-center gap-3 group shrink-0"
                    aria-label="HSNC University & School Of Applied Sciences"
                >
                    <img
                        src={LOGO_URL}
                        alt="HSNC University SAS Logo"
                        className="h-20 sm:h-24 md:h-28 w-auto object-contain"
                        data-testid="header-logo"
                    />
                </a>

                
            </div>
            <div className="hero-accent-stripe h-[2px] opacity-70" />
        </header>
    );
}
